var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _g18, _path19, _g19, _path20, _g20, _path21, _g21, _path22, _g22, _path23, _g23, _path24, _g24, _path25, _g25, _path26, _g26, _path27, _g27, _path28, _g28, _path29, _g29, _path30, _g30, _path31, _g31, _path32, _g32, _path33, _g33, _path34, _g34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCropsSweetcorn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7573 19.0242C21.9735 19.0178 21.0612 18.4331 21.0547 17.932C21.0483 17.161 21.7872 15.9403 22.269 15.9339C23.0079 15.921 23.9588 16.5442 23.9459 17.0261C23.9202 17.887 23.2392 19.0242 22.7573 19.0242Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.811 15.9658C22.9116 15.908 22.1855 15.4005 22.2369 14.8543C22.314 13.9227 22.9501 12.9654 23.477 13.0682C24.3636 13.2353 25.096 13.5372 25.0189 14.1412C24.8904 15.1499 24.3572 15.998 23.811 15.9658Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7009 12.0788C21.3948 12.0595 22.32 12.6249 22.3264 13.0746C22.3393 13.8649 21.6839 14.9571 21.1892 14.97C20.5018 14.9893 19.4995 14.3853 19.5059 13.9549C19.5187 13.1967 20.2191 12.0916 20.7009 12.0788Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6719 15.0407C27.6976 15.9273 27.1194 16.9617 26.5989 16.9553C25.9051 16.9489 24.9799 16.3963 24.9606 15.9723C24.922 15.182 25.5838 14.0127 26.0657 14.0191C26.811 14.0191 27.6591 14.5652 27.6719 15.0407Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2651 13.2482C31.2394 14.1862 30.7254 15.0407 30.2114 15.015C29.4468 14.9765 28.6309 14.4239 28.6309 13.9485C28.6309 13.1068 29.2091 12.1431 29.7038 12.1688C30.4812 12.2073 31.2779 12.7599 31.2651 13.2482Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8458 9.32898C22.5011 9.3354 23.4263 9.90079 23.4327 10.2991C23.4391 11.0766 22.7902 12.1302 22.3019 12.1238C21.5952 12.1174 20.7021 11.5327 20.715 11.083C20.7407 10.2927 21.3639 9.32898 21.8458 9.32898Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.6512 12.2522C28.6704 13.0618 28.0922 14.0512 27.6103 14.0512C26.9164 14.0512 26.017 13.473 26.0041 13.0232C25.9913 12.233 26.5824 11.1986 27.0449 11.205C27.7517 11.2178 28.6447 11.7961 28.6512 12.2522Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9318 13.0939C24.193 13.081 23.332 12.5157 23.332 12.0466C23.3385 11.327 24.0195 10.2605 24.4564 10.2669C25.2145 10.2798 26.0562 10.8388 26.0369 11.3206C26.0176 12.1366 25.4137 13.1003 24.9318 13.0939Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3897 9.37391C22.6444 9.34821 21.8028 8.84064 21.8028 8.40375C21.7964 7.74199 22.4902 6.69473 22.94 6.70758C23.6596 6.72685 24.4884 7.28582 24.4627 7.73556C24.4113 8.5451 23.8587 9.38676 23.3897 9.37391Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4994 7.64561C26.2061 7.67131 27.0092 8.1853 27.0028 8.61576C27.0028 9.41245 26.4181 10.3505 25.9427 10.3312C25.191 10.2991 24.375 9.77867 24.375 9.33535C24.3814 8.60291 25.0303 7.62633 25.4994 7.64561Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.1068 10.5047C32.1004 11.3335 31.5992 12.2201 31.1431 12.2201C30.3656 12.2137 29.5561 11.6804 29.5625 11.1793C29.569 10.389 30.1151 9.47025 30.5648 9.49595C31.3615 9.5345 32.1132 10.0292 32.1068 10.5047Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9821 8.56431C28.5988 8.54503 29.5433 9.1297 29.5562 9.54732C29.5819 10.3119 29.055 11.2499 28.586 11.2692C27.9885 11.2885 27.0055 10.7102 26.9798 10.3312C26.9476 9.63084 27.5387 8.57716 27.9821 8.56431Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8574 18.7607C24.018 18.3624 24.2429 17.7841 24.4742 17.2059C24.4935 17.1545 24.5513 17.1031 24.6027 17.071C25.1488 16.7047 25.605 17.1159 26.0612 17.2958C26.3053 17.3922 26.5623 17.6685 26.6394 17.919C26.6908 18.0797 26.4724 18.4073 26.286 18.5358C25.7977 18.8828 25.2645 19.1719 24.7441 19.4739C24.275 19.7437 23.8703 19.4996 23.8574 18.7607Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5908 16.0044C30.2631 16.3642 30.0832 16.6662 29.8198 16.8268C29.415 17.071 28.9524 17.2316 28.5091 17.4179C27.9887 17.6364 27.5582 17.3472 27.6675 16.7947C27.7703 16.2871 27.9887 15.8117 28.1686 15.317C28.1879 15.2592 28.2393 15.2078 28.2843 15.1692C28.8304 14.7066 29.3122 15.1435 29.7877 15.3234C30.0511 15.4326 30.2503 15.7153 30.5908 16.0044Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.51 9.38678C30.8161 9.36109 30.1479 8.89207 30.1543 8.4359C30.1736 7.70346 30.6105 7.03527 31.0474 7.05455C31.6963 7.09309 32.3645 7.56211 32.3517 7.97973C32.3388 8.77642 31.9597 9.39963 31.51 9.38678Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2532 8.55796C28.6814 8.56438 27.9168 8.06967 27.9104 7.68417C27.8976 7.06096 28.3666 6.25785 28.7585 6.245C29.3689 6.2193 30.1463 6.73971 30.1334 7.15091C30.1077 7.88334 29.6901 8.55153 29.2532 8.55796Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5575 5.42265C27.2321 5.44192 27.9324 5.89809 27.9132 6.30928C27.8875 6.94535 27.3863 7.74846 27.0137 7.75489C26.3969 7.76774 25.6002 7.23447 25.6195 6.8297C25.6516 6.19364 26.172 5.41622 26.5575 5.42265Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7192 6.90036C24.0767 6.89393 23.3764 6.44419 23.3829 6.03942C23.3893 5.35838 23.8968 4.61952 24.3402 4.63237C24.9762 4.65164 25.6444 5.06926 25.6508 5.46118C25.6637 6.09082 25.1369 6.90678 24.7192 6.90036Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6041 21.7097C21.5078 20.8038 21.4178 19.975 21.3086 18.9984C21.9125 19.2875 22.5614 19.2233 22.7735 19.8722C22.9598 20.444 22.4715 21.1957 21.6041 21.7097Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0273 15.1755C21.2738 15.3619 21.5179 15.9529 20.7726 16.9745C20.5221 16.377 20.2843 15.8116 20.0273 15.1755Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5788 4.98567C30.5082 5.66671 30.1869 6.11646 29.795 6.07148C29.1332 6.00081 28.6706 5.66672 28.6963 5.28122C28.7477 4.67728 29.1718 4.10546 29.5316 4.15044C30.2126 4.24039 30.6238 4.56806 30.5788 4.98567Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5007 5.64754C32.4814 6.26433 32.1281 6.79117 31.749 6.77832C31.1836 6.75262 30.6182 6.36071 30.6311 5.99449C30.6439 5.43552 31.023 4.82515 31.3507 4.81873C31.8582 4.8123 32.5136 5.28132 32.5007 5.64754Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9857 4.66454C25.3881 4.64526 24.8677 4.27262 24.8999 3.8807C24.9448 3.28318 25.3496 2.69852 25.7094 2.80132C26.1334 2.91697 26.7502 2.85272 26.8016 3.51448C26.8402 4.0863 26.3904 4.67739 25.9857 4.66454Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8242 4.3047C28.5415 4.67092 28.3295 5.19133 27.9568 5.35838C27.5135 5.55755 26.7104 4.94719 26.8068 4.59382C26.9224 4.16335 26.9096 3.57226 27.5264 3.47588C28.0082 3.39878 28.6893 3.86138 28.8242 4.3047Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1961 3.19325C31.1447 3.72009 30.8941 4.06704 30.5857 4.03491C30.0781 3.98351 29.7119 3.72009 29.7376 3.41812C29.7762 2.9491 30.1038 2.50579 30.3865 2.54434C30.9134 2.62143 31.2282 2.87201 31.1961 3.19325Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6781 3.70726C32.6652 4.1827 32.389 4.59389 32.0999 4.58104C31.663 4.56177 31.2261 4.2598 31.2325 3.9771C31.2389 3.54663 31.5345 3.07119 31.7915 3.07119C32.1834 3.06477 32.6909 3.42456 32.6781 3.70726Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6319 2.94909C27.1693 2.93624 26.7645 2.64069 26.7902 2.33872C26.8223 1.87613 27.1372 1.42639 27.4134 1.50349C27.7411 1.59344 28.223 1.54204 28.2551 2.05603C28.2936 2.50577 27.9467 2.96194 27.6319 2.94909Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.8311 2.66641C29.6126 2.94911 29.4456 3.35387 29.1565 3.48237C28.8095 3.63657 28.1927 3.16113 28.2634 2.89128C28.3533 2.55719 28.3405 2.09459 28.8224 2.02392C29.2014 1.9661 29.7283 2.32589 29.8311 2.66641Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.782 1.70253C32.7306 2.22937 32.48 2.57631 32.1716 2.54419C31.6641 2.49279 31.2978 2.22937 31.3235 1.9274C31.3621 1.45838 31.6898 1.01506 31.9725 1.05361C32.4993 1.13071 32.8141 1.38128 32.782 1.70253Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2237 1.45837C28.7611 1.44552 28.3563 1.1564 28.382 0.848001C28.4141 0.385408 28.729 -0.0643344 29.0052 0.0127644C29.3329 0.102713 29.8148 0.051313 29.8469 0.565305C29.8854 1.00862 29.5385 1.46479 29.2237 1.45837Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.417 1.17569C31.1986 1.45838 31.0315 1.86315 30.7424 1.99165C30.3955 2.14585 29.7787 1.6704 29.8493 1.40056C29.9393 1.06646 29.9264 0.610296 30.4083 0.533197C30.7874 0.475373 31.3142 0.835167 31.417 1.17569Z",
    fill: "#EBC905"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.6565 15.7089C35.607 17.4115 34.579 19.6602 33.4418 21.8383C31.54 25.4812 29.7218 29.1755 27.775 32.7992C26.5093 35.1571 24.9931 37.3673 23.0527 39.2498C21.8963 40.3741 20.5856 41.2543 18.9729 41.5499C16.5957 41.9868 14.3149 40.644 13.4668 38.3053C12.5545 35.7867 12.9143 33.3645 14.3149 31.1608C18.1377 25.1471 23.0206 20.2899 29.7218 17.5015C32.0348 16.5377 34.4505 15.998 36.9305 15.7218C37.1361 15.6896 37.3417 15.7089 37.6565 15.7089Z",
    fill: "#36965C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.4179C8.43689 14.4817 10.268 11.9118 12.4525 11.5006C14.5084 11.1151 16.1789 11.8796 17.6823 13.1711C19.5712 14.7837 20.2459 16.981 20.7727 19.3133C21.2096 21.2279 20.9205 22.6285 19.3335 24.0227C17.6888 25.4619 16.3395 27.2801 15.0353 29.0534C13.4355 31.225 12.2083 33.5894 12.4589 36.4485C12.3818 36.4485 12.2983 36.4485 12.2212 36.4485C12.1184 35.3627 11.9642 34.2768 11.9256 33.191C11.81 29.6509 12.6645 26.2778 13.7182 22.9369C14.3028 21.0865 14.8746 19.2297 15.4015 17.3665C15.53 16.9168 15.5364 16.4092 15.4914 15.9402C15.4272 15.2848 15.0481 14.9315 14.3992 14.9957C13.6603 15.0664 12.9022 15.2142 12.2147 15.484C11.0133 15.953 9.8568 16.5441 8.68104 17.0902C8.48829 17.1802 8.2827 17.2766 8 17.4179Z",
    fill: "#36965C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_138_9275",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 0,
    width: 30,
    height: 45
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6638 0H8V45H37.6638V0Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_138_9275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6768 42.1795C17.3749 42.9183 17.1564 43.5544 16.8609 44.1455C16.4882 44.8843 15.8329 45.1413 15.0234 44.955C13.0124 44.4924 12.5626 43.6957 13.2501 41.7683C13.43 41.2671 13.6292 40.7724 13.854 40.1877C14.9141 41.325 16.122 41.9739 17.6768 42.1795Z",
    fill: "#36965C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsSweetcorn);
export default __webpack_public_path__ + "static/media/ic-crops-Sweetcorn.58e28af204c3933b4c1f47659e6218d6.svg";
export { ForwardRef as ReactComponent };